<template>
  <div class="complaintlList">
    <!-- 返回导航栏 -->

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadMoreList"
      v-if="listData.length > 0"
    >
      <div class="wrapper-box">
        <div class="items-box" v-for="(lists,index) in listData" :key="index" @click="goDetail(lists)">
          <div class="info-box">
            <div class="title">{{lists.complain_problem}}</div>
            <div class="dates">{{lists.complain_time.substring(0,10)}}</div>
            <div class="types">{{lists.complain_classify}}</div>
          </div>
          <div class="lookmore">
            <div class="texts">{{lists.subStatue}}</div>
            <img src="../../assets/travelAgency/ic_righticon.png" alt class="right-icon" />
          </div>
        </div>
      </div>
    </van-list>

    <empty :type="3" v-if="listData.length === 0 && !loading"></empty>
  </div>
</template>
<script>
    import api from '../../service/modules/guide';
    import util from '../../utils/common';
    import empty from 'comps/empty';
    export default {
        components: {
            empty
        },

        data () {
            return {
                listData: [],
                name: '',
                finished: false,
                loading: false,
                page: 1,
                total: 0,
                pageSize: 10
            };
        },

        computed: {},

        watch: {},

        methods: {
            loadMoreList () {
                this.getComplaint();
            },
            test () {},
            myPending (index) {
                this.currentIndex = index;
            },
            // 拉取投诉列表
            getComplaint () {
                this.loading = true;
                api
                    .getComplaint({
                        p: this.page,
                        pageSize: this.pageSize,
                        name: this.name
                    })
                    .then(res => {
                        this.loading = false;
                        if (res.ret === 0) {
                            this.finished = false;
                            this.listData = [...this.listData, ...res.data.list];
                            this.total = res.data.totalSize;
                            if (this.total <= this.page * this.pageSize) {
                                this.finished = true;
                            } else {
                                this.page++;
                            }
                        }
                    });
            },

            goDetail (value) {
                this.$store.commit('complaint/setHandleWorkbench', false);
                util.setJsonLocal('item', value);
                this.$store.commit('complaint/getItemList', value);
                this.goRoute(value)
            },
            goRoute (value) {
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: `${this.globalApp.getSystemInfo().host}web/#/complaint/detailList/complaintSheet`,
                        isFullScreen: 0,
                        setTitle: '',
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            }
        },

        mounted () {
            this.name = this.$route.query.name || '';
            this.listData = []
            this.getComplaint()
        },
        created () {}
    };
</script>
<style scoped lang="less">
.complaintlList {
  width: 100%;
  height: 100%;
  background: rgba(251, 251, 251, 1);
  .wrapper-box {
    box-sizing: border-box;
    padding: 0 12px;
    background: #fff;

    .items-box {
      box-sizing: border-box;
      padding: 16px 0;
      display: flex;
      align-items: flex-end;
      border-bottom: 1px solid #eeeeee;
      background: #fff;

      &:last-child {
        border-bottom: none;
      }

      .info-box {
        flex: 1;

        .title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin-bottom: 12px;
        }
        .dates {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
          margin-bottom: 4px;
        }
        .types {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
      }
      .lookmore {
        height: 16px;
        display: flex;
        align-items: center;
        overflow: hidden;
        .texts {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(54, 179, 116, 1);
          line-height: 12px;
          margin-right: 4px;
        }
        .right-icon {
          width: 12px;
          height: 12px;
          margin-top: 2px;
        }
      }
    }
  }
}
</style>
